import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api/studs`;

export const studService = {
  // Get all studs
  getAll: async () => {
    const response = await axios.get(API);
    return response.data;
  },

  // Get studs by breed
  getByBreed: async (breedId) => {
    const response = await axios.get(`${API}/breed/${breedId}`);
    return response.data;
  },

  // Get single stud
  getById: async (id) => {
    const response = await axios.get(`${API}/${id}`);
    return response.data;
  },

  // Create new stud
  create: async (studData) => {
    const response = await axios.post(API, studData);
    return response.data;
  },

  // Update stud
  update: async (id, studData) => {
    const response = await axios.put(`${API}/${id}`, studData);
    return response.data;
  },

  // Delete stud
  delete: async (id) => {
    const response = await axios.delete(`${API}/${id}`);
    return response.data;
  },

  // Upload image
  uploadImage: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await axios.post(`${API}/upload-image`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data.image;
  }
};
